// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__3hw8Z","hiddenCard":"card_hiddenCard__2b_h6","black":"card_black__3buTR","red":"card_red__1qeUA","value":"card_value__2PP1I","suit":"card_suit__2oS8P"};